// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"0dac912d","707":"381f8b96","729":"10d80f74"}[chunkId] + ".js";
};